import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatPrice,
  getSystemSettings,
  customStyle
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from 'moment';
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

let groupArr = [
  { id: 1, name: "Document No" },
  { id: 2, name: "Document Date" },
  { id: 3, name: "Supplier" },
  { id: 4, name: "Branch" }
];

const PurchaseInvoiceReport = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  //getting context values here
  let { loading, setLoading, dataPaginating, setDataPaginating, generalSettings } = useContext(SettingsContext);
  const { authUserInfo, supplierForSearch, getSupplier } = useContext(UserContext);
  let { branchForSearch, ingredientItemForSearch, ingredientGroupForSearch, getIngredientGroup } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRef1 = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);
  const [ingredientGroup, setIngredientGroup] = useState(null);
  const [item, setItem] = useState(null);
  const [supplier, setSupplier] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [option, setOption] = useState("print");
  const [group, setGroup] = useState(null);

  useEffect(() => {
    if(!ingredientGroupForSearch){
      getIngredientGroup();
    }
    if(!supplierForSearch){
      getSupplier();
    }
    setSiteName(getSystemSettings(generalSettings, "siteName"));

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  let common_toast = {
    position: "bottom-center",
    closeButton: false,
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  }

  const handleGroup = (group)=>{
    setIngredientGroup(group)
  }

  const handleBranch = (branch) => {
    setBranch(branch)
  }

  const handleItem = (item) => {
    setItem(item)
  }

  const handleOption = (e) => {
    setOption(e.target.value)
  }

  const handleSupplier = (supplier) => {
    setSupplier(supplier)
  }

  //get excel reports filter
  const getExcelReport = () => {
    setReportData(null);
    setGeneratedReport(false)
    if (
      startDate !== null &&
      endDate !== null &&
      group !== null
    ) {
      if (option === 'print') {
        getReport()
      }
      else {
        getSummaryReport()
      }
    } else {
      toast.error(
        `${_t(
          t(
            "Please select from date, to date and group"
          )
        )}`,
        common_toast
      );
    }
  };

  //pi report
  const getReport = async () => {
    setDataPaginating(true);
    var fromDate = moment(startDate).format("YYYY-MM-DD");
    var toDate = moment(endDate).format("YYYY-MM-DD");
    const url = BASE_URL + "/settings/get-purchased-invoice-report";
    let formData = new FormData();
    formData.append("fromDate", fromDate);
    formData.append("toDate", toDate);
    formData.append("branch_id", branch?.id ?? "");
    formData.append("ingredient_group", ingredientGroup?.id ?? "");
    formData.append("item_id", item?.id ?? "");
    formData.append("supplier_id", supplier?.id ?? "");
    formData.append("group_by", group.name);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        console.log("ReportResult", res);
        setGeneratedReport(true);
        setReportData(res.data)
        setDataPaginating(false);
        componentRef.current.handleDownload();
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, common_toast);
      });
  }

  //summary report
  const getSummaryReport = async () => {
    setDataPaginating(true);
    var fromDate = moment(startDate).format("YYYY-MM-DD");
    var toDate = moment(endDate).format("YYYY-MM-DD");
    const url = BASE_URL + "/settings/get-purchased-summary-report";
    let formData = new FormData();
    formData.append("fromDate", fromDate);
    formData.append("toDate", toDate);
    formData.append("branch_id", branch?.id ?? "");
    formData.append("ingredient_group", ingredientGroup?.id ?? "");
    formData.append("item_id", item?.id ?? "");
    formData.append("supplier_id", supplier?.id ?? "");
    formData.append("group_by", group.name);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        console.log("ReportResult", res);
        setGeneratedReport(true);
        setReportData(res.data)
        setDataPaginating(false);
        componentRef1.current.handleDownload();
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`,common_toast)
      });
  }

  return (
    <>
      <Helmet>
        <title>{_t(t("Purchase Invoice Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Purchase Invoice Report"
        sheet="sheet 1"
        buttonText="Purchase Invoice Detail"
        ref={componentRef}
      />

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xlss"
        filename="Purchase Invoice Summary Report"
        sheet="sheet 1"
        buttonText="Purchase Summary Detail"
        ref={componentRef1}
      />

      {/* Excel Report Details*/}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && option === "print" && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="17" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Purchase Invoice Detail Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Group Name"))}
                                  </th>
                                  {group?.name !== "Document No" && <th
                                    scope="col"
                                  >
                                    {_t(t("Invoice No"))}
                                  </th>}
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Manual Invoice No"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Ref No"))}
                                  </th>                                  
                                  {group?.name !== "Document Date" && <th
                                    scope="col"
                                  >
                                    {_t(t("Date"))}
                                  </th>}
                                  {group?.name !== "Branch" && <th
                                    scope="col"
                                  >
                                    {_t(t("Branch Name"))}
                                  </th>}
                                  {group?.name !== "Supplier" && <th
                                    scope="col"
                                  >
                                    {_t(t("Supplier Name"))}
                                  </th>}
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Ingredient Group"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Item Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Unit"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Payment Type"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Qty"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Rate"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Amount"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Discount Amount"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Tax Amount"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Advance Tax"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Total Amount"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* {console.log("309 ", reportData)} */}
                                {/* loop here*/}
                                {
                                  Object.keys(reportData).length > 0 && Object.keys(reportData).map(
                                    (group_name, index) => {
                                      let totalQty = 0;
                                      let totalAmount = 0;
                                      let totalDisAmount = 0;
                                      let totalTaxAmount = 0;
                                      let totalAdvTaxAmount = 0;
                                      let totalNetAmount = 0;
                                      return (
                                        <div key={index}>

                                          <tr>
                                            <th
                                              scope="row"
                                            >
                                              {group_name}
                                            </th>
                                          </tr>
                                          {reportData[group_name]?.length > 0 && reportData[group_name].map((item, i) => {
                                            totalQty += item.qty ? parseFloat(item.qty) : 0;
                                            totalAmount += item.amount ? parseFloat(item.amount) : 0;
                                            totalDisAmount += item.discount ? parseFloat(item.discount) : 0;
                                            totalTaxAmount += item.tax ? parseFloat(item.tax) : 0;
                                            totalAdvTaxAmount += item.advance_tax ? parseFloat(item.advance_tax) : 0;
                                            totalNetAmount += item.total ? parseFloat(item.total) : 0;

                                            return (
                                              <tr>
                                                <td></td>
                                                {group?.name !== "Document No" && <td
                                                  scope="row"
                                                >
                                                  {item.invoice_number}
                                                </td>}
                                                <td
                                                  scope="row"
                                                >
                                                  {item.manual_invoice_no}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.ref_doc_identity}
                                                </td>
                                                {group?.name !== "Document Date" && <td
                                                  scope="row"
                                                >
                                                  <Moment format="LL">
                                                    {item.purchase_date}
                                                  </Moment>
                                                </td>}
                                                {group?.name !== "Branch" && <td
                                                  scope="row"
                                                >
                                                  {item.branch_name}
                                                </td>}
                                                {group?.name !== "Supplier" && <td
                                                  scope="row"
                                                >
                                                  {item.supplier_name}
                                                </td>}
                                                <td
                                                  scope="row"
                                                >
                                                  {item.group_name}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.ingredient_name}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.unit}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.payment_type}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.qty}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.rate}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.amount && parseFloat(item.amount).toFixed(2)}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.discount && parseFloat(item.discount).toFixed(2)}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.tax && parseFloat(item.tax).toFixed(2)}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.advance_tax && parseFloat(item.advance_tax).toFixed(2)}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.total && parseFloat(item.total).toFixed(2)}
                                                </td>
                                              </tr>
                                            );
                                          })}
                                          <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <th
                                              colspan="2"
                                              scope="row"
                                            >
                                              Total
                                            </th>
                                            <td
                                              scope="row"
                                            >
                                              <strong>
                                                {formatPrice(totalQty)}
                                              </strong>
                                            </td>
                                            <td></td>
                                            <td
                                              scope="row"
                                            >
                                              <strong>
                                                {formatPrice(totalAmount)}
                                              </strong>
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              <strong>
                                                {formatPrice(totalDisAmount)}
                                              </strong>
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              <strong>
                                                {formatPrice(totalTaxAmount)}
                                              </strong>
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              <strong>
                                                {formatPrice(totalAdvTaxAmount)}
                                              </strong>
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              <strong>
                                                {formatPrice(totalNetAmount)}
                                              </strong>
                                            </td>
                                          </tr>
                                        </div>
                                      );
                                    }
                                  )
                                }
                              </tbody>

                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="7"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Excel Report Summary*/}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && option !== "print" && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xlss"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="13" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Purchase Invoice Summary Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Group Name"))}
                                  </th>
                                  {group?.name !== "Document No" && <th
                                    scope="col"
                                  >
                                    {_t(t("Invoice No"))}
                                  </th>}
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Manual Invoice No"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Ref No"))}
                                  </th>
                                  {group?.name !== "Document Date" && <th
                                    scope="col"
                                  >
                                    {_t(t("Date"))}
                                  </th>}
                                  {group?.name !== "Branch" && <th
                                    scope="col"
                                  >
                                    {_t(t("Branch Name"))}
                                  </th>}
                                  {group?.name !== "Supplier" && <th
                                    scope="col"
                                  >
                                    {_t(t("Supplier Name"))}
                                  </th>}
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Amount"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Discount Amount"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Tax Amount"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Advance Tax"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Net Total"))}
                                  </th>
                                  <th>
                                    {_t(t("Description"))}
                                  </th>
                                  <th>
                                    {_t(t("Credit Limit Days"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* {console.log("309 ", reportData)} */}
                                {/* loop here*/}
                                {
                                  Object.keys(reportData).length > 0 && Object.keys(reportData).map(
                                    (group_name, index) => {
                                      let totalAmount = 0;
                                      let totalDisAmount = 0;
                                      let totalTaxAmount = 0;
                                      let totalAdvTaxAmount = 0;
                                      let totalNetAmount = 0;
                                      return (
                                        <div key={index}>

                                          <tr>
                                            <th
                                              scope="row"
                                            >
                                              {group_name}
                                            </th>
                                          </tr>
                                          {reportData[group_name]?.length > 0 && reportData[group_name].map((item, i) => {
                                            totalAmount += item.amount ? parseFloat(item.amount) : 0;
                                            totalDisAmount += item.discount ? parseFloat(item.discount) : 0;
                                            totalTaxAmount += item.tax ? parseFloat(item.tax) : 0;
                                            totalAdvTaxAmount += item.advance_tax ? parseFloat(item.advance_tax) : 0;
                                            totalNetAmount += item.total ? parseFloat(item.total) : 0;

                                            return (
                                              <tr>
                                                <td></td>
                                                {group?.name !== "Document No" && <td
                                                  scope="row"
                                                >
                                                  {item.invoice_number}
                                                </td>}
                                                <td
                                                  scope="row"
                                                >
                                                  {item.manual_invoice_no}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.ref_doc_identity}
                                                </td>
                                                {group?.name !== "Document Date" && <td
                                                  scope="row"
                                                >
                                                  <Moment format="LL">
                                                    {item.purchase_date}
                                                  </Moment>
                                                </td>}
                                                {group?.name !== "Branch" && <td
                                                  scope="row"
                                                >
                                                  {item.branch_name}
                                                </td>}
                                                {group?.name !== "Supplier" && <td
                                                  scope="row"
                                                >
                                                  {item.supplier_name}
                                                </td>}
                                                <td
                                                  scope="row"
                                                >
                                                  {item.amount ? parseFloat(item.amount).toFixed(2) : 0}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.discount ? parseFloat(item.discount).toFixed(2) : 0}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.tax ? parseFloat(item.tax).toFixed(2) : 0}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.total_advance_tax ? parseFloat(item.total_advance_tax).toFixed(2) : 0}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.total ? parseFloat(item.total).toFixed(2) : 0}
                                                </td>

                                                <td
                                                  scope="row"
                                                >
                                                  {item.desc ? item.desc : "-"}
                                                </td>

                                                <td
                                                  scope="row"
                                                >
                                                  {item.credit_limit_days ? item.credit_limit_days : "-"}
                                                </td>
                                              </tr>
                                            );
                                          })}
                                          <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <th
                                              colSpan={2}
                                              scope="row"
                                            >
                                              Total
                                            </th>
                                            <td
                                              scope="row"
                                            >
                                              <strong>
                                                {formatPrice(totalAmount)}
                                              </strong>
                                            </td>
                                            <td
                                              scope="row"
                                            >
                                              <strong>
                                                {formatPrice(totalDisAmount)}
                                              </strong>
                                            </td>
                                            <td
                                              scope="row"
                                            >
                                              <strong>
                                                {formatPrice(totalTaxAmount)}
                                              </strong>
                                            </td>
                                            <td
                                              scope="row"
                                            >
                                              <strong>
                                                {formatPrice(totalAdvTaxAmount)}
                                              </strong>
                                            </td>
                                            <td
                                              scope="row"
                                            >
                                              <strong>
                                                {formatPrice(totalNetAmount)}
                                              </strong>
                                            </td>
                                          </tr>
                                        </div>
                                      );
                                    }
                                  )
                                }
                              </tbody>

                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="7"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating}/>

                    {/* spin loading ends */}

                    {/* Loading effect {loading === true ? (
                        tableLoading()
                      ) : ( */}

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0" >
                          <ul className="t-list fk-breadcrumb col-12">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Purchase Invoice Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={branch}
                            classNamePrefix="select"
                            isClearable
                            className="table-text"
                            onChange={handleBranch}
                            styles={customStyle}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>

                        <div className="col-5 d-flex justify-content-end p-0">
                         <div className="d-inline mr-3 d-flex align-items-center">
                          <input
                            type="radio"
                            className="form-check-input pointer-cursor"
                            id="print"
                            name="print"
                            value="print"
                            onChange={(e) => {
                              handleOption(e);
                            }}
                            checked={
                              option === "print"
                            }
                          />
                          <label
                            className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                            htmlFor="print"
                            style={{ fontSize: "16px", borderRadius: "5px" }}
                          >
                            <i className="fa fa-table" aria-hidden="true"></i> {_t(t("Download Report"),)}
                          </label>
                         </div>

                         <div className="d-inline mr-2 d-flex align-items-center">
                          <input
                            type="radio"
                            className="form-check-input pointer-cursor"
                            id="print_summary"
                            name="print_summary"
                            value="print_summary"
                            onChange={(e) => {
                              handleOption(e);
                            }}
                            checked={
                              option === "print_summary"
                            }
                          />
                          <label
                            className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                            htmlFor="print_summary"
                            style={{ fontSize: "16px", borderRadius: "5px" }}
                          >
                            <i className="fa fa-table" aria-hidden="true"></i> {_t(t("Download Summary"))}
                          </label>
                         </div>
                        </div>
                        
                      </div>
                      <div className="row mt-3">
                      
                      <div className="col-3">
                        <Select
                          options={ingredientGroupForSearch ? ingredientGroupForSearch : []}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          value={ingredientGroup}
                          classNamePrefix="select"
                          isClearable
                          className="table-text"
                          onChange={handleGroup}
                          styles={customStyle}
                          maxMenuHeight="200px"
                          placeholder={_t(t("Select a group")) + ".."}
                        />
                      </div>

                      <div className="col-2">
                        <Select
                          options={ingredientItemForSearch ? ingredientItemForSearch : []}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          value={item}
                          styles={customStyle}
                          isClearable
                          classNamePrefix="select"
                          className="table-text"
                          onChange={handleItem}
                          maxMenuHeight="200px"
                          placeholder={_t(t("Select item")) + ".."}
                        />
                      </div>

                      <div className="col-3">
                        <Select
                          options={supplierForSearch ? supplierForSearch : []}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          value={supplier}
                          styles={customStyle}
                          isClearable
                          classNamePrefix="select"
                          className="table-text"
                          onChange={handleSupplier}
                          maxMenuHeight="200px"
                          placeholder={_t(t("Select a supplier")) + ".."}
                        />
                       </div>
                        <div className="col-2">
                          <Select
                            options={groupArr && groupArr}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.name}
                            value={group}
                            styles={customStyle}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={(group) => setGroup(group)}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select group")) + ".."}
                          />
                        </div>

                        <div className="col-2 t-mb-15 mb-md-0 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getExcelReport()}
                          >
                            GENERATE REPORT
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>

    </>
  );
}

export default PurchaseInvoiceReport;